export const systemUnavailable = {
  created() {
    this.$on('system:unavailable', this.showMessageError.bind(this))

    if (Object.prototype.hasOwnProperty.call(this.$root, 'system-error')) {
      return
    }

    Object.defineProperty(this.$root, 'system-error', {
      value: this.createMessageErrorElement(),
      writable: false
    })
  },
  computed: {
    savedMessageError() {
      return this.$root['system-error']
    }
  },
  methods: {
    showMessageError() {
      this.savedMessageError.classList.remove('hide')
      setTimeout(() => {
        this.savedMessageError.classList.add('hide')
      }, 4000)
    },
    createMessageErrorElement() {
      let msgElement = document.createElement('div')
      msgElement.className = 'card card-message card-message-error hide'
      msgElement.innerText = this.$t('errorMessage.expired')
      document.body.appendChild(msgElement)
      return msgElement
    }
  }
}
